import { useState } from "react";
import { Button, Form, Modal, message } from "antd";

import Heading from "components/Heading/Heading";
import DataTable from "components/Tables/DataTable";
import {
  useAddMeagureMutation,
  useDeleteMeagureMutation,
  useEditMeagureMutation,
  useGetMeaguresQuery,
} from "../../../redux/Service/meaguresApi";
import FormModal from "./FormModal";

function Meagures() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { data: meaguresData, isLoading } = useGetMeaguresQuery(undefined);
  const meagures = meaguresData?.ResponseObject ?? [];

  const [addMeagure, { isLoading: isAdding }] = useAddMeagureMutation();
  const [updateMeagure, { isLoading: isUpdating }] = useEditMeagureMutation();
  const [deleteMeagure, { isLoading: isDeleting }] = useDeleteMeagureMutation();

  const columns: any = [
    {
      title: "كود المقاس",
      dataIndex: "MeagureID",
      key: "MeagureID",
    },
    {
      title: "اسم المقاس",
      dataIndex: "MeagureName",
      key: "MeagureName",
      width: 120,
    },
  ];

  const handleOk = async (values: any) => {
    try {
      let response;

      if (isEditing) {
        response = await updateMeagure(values).unwrap();
      } else {
        response = await addMeagure(values).unwrap();
      }

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل المقاس بنجاح" : "تمت إضافة المقاس بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف المقاس "${record.MeagureName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteMeagure(record.MeagureID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف المقاس بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          meagures={meagures}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={meagures}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Meagures;
